import React from "react";
import {
  TextField,
  InputAdornment,
  Select,
  MenuItem,
  Box,
  makeStyles,
  OutlinedInput,
} from "@material-ui/core";
import FieldTranslation from "../../../components/FieldTranslation";

const useStyles = makeStyles(() => ({
  selectNoMargin: {
    marginBottom: 0,
    "& .MuiInputBase-root": {
      marginBottom: 0,
    },
    "& .MuiFormControl-root": {
      marginBottom: 0,
    },
  },
}));

export default function FieldMultilang({
  label = "label",
  name = "name",
  value,
  onChange,
  availableLanguages = [],
  valuesLng,
  defaultLanguage = "en",
  handleValuesLng,
  required = false,
  fullWidth = true,
  multiline,
  style,
  placeholder,
  hasFormat = false,
  formatValue,
  onFormatChange,
}) {
  const classes = useStyles();
  const safeFormatValue = ["TXT", "MD"].includes(formatValue)
    ? formatValue
    : "TXT";

  return (
    <Box style={style} mb={2}>
      {hasFormat && (
        <Box display="flex" justifyContent="flex-end" style={{ lineHeight: 1 }}>
          <Select
            className={classes.selectNoMargin}
            name={`${name}_format`}
            value={safeFormatValue}
            onChange={onFormatChange}
            variant="outlined"
            margin="dense"
            size="small"
            input={
              <OutlinedInput
                margin="dense"
                style={{
                  paddingTop: 0,
                  paddingBottom: 0,
                  height: 24,
                  fontSize: 12,
                }}
              />
            }
          >
            <MenuItem value="TXT">Testo semplice</MenuItem>
            <MenuItem value="MD">Markdown</MenuItem>
          </Select>
        </Box>
      )}

      <TextField
        label={label}
        name={name}
        value={value}
        onChange={onChange}
        required={required}
        fullWidth={fullWidth}
        margin="dense"
        multiline={multiline}
        placeholder={placeholder}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <FieldTranslation
                language={defaultLanguage}
                items={valuesLng}
                availableLanguages={availableLanguages}
                onChange={handleValuesLng}
                title={label}
              />
            </InputAdornment>
          ),
        }}
      />
    </Box>
  );
}
